import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ReviewSummaryResult from '../../../widgets/reviewSummary/ReviewSummaryResult'
import {
  getReviewSummaryMutiData,
  getSchemaReviewSummary,
  getSchemaReviewSummaryMuti,
} from '../../../redux/actions/reviewSummary'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import scrollToComponent from 'react-scroll-to-component'
import { Message, Panel, Row } from 'rsuite'
import ReviewSummaryResultMuti from '../../../widgets/reviewSummary/ReviewSummaryResultMuti'
import ApprovedExpert from '../../../widgets/approvedExpert/ApprovedExpert'

export default function ReviewSummaryMulti() {
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [reviewSummary, setReviewSummary] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '0219B95A-097A-444C-B903-7F39EBBBA6EE'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      console.log('handleGetSchema request', request)
      setReviewSummary('')
      setSingleProject('')
      const _schema = await getSchemaReviewSummaryMuti(request, 5, 1)
      console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setReviewSummary('')
      setSingleProject(obj)
      const response = await getSchemaReviewSummary(obj.id)
      console.log('onSingleSubmit response', response)

      let _schema = response?.model?.forms

      if (_schema) {
        _schema['header'] = obj.projectName
        setReviewSummary(_schema)
      }
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    doneLoading()
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      setReviewSummary('')
      setSingleProject('')
      const response = await getReviewSummaryMutiData(request, pagesize, pagenumber)
      setProjectList(response?.forms?.projectList || [])
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onComplete = (_schema) => {
    let idList = sessionStorage.getItem('mutiReview')
    idList.replace(
      reviewSummary.ReviewerSummary.projectVersionId,
      _schema.projectVersionId || _schema.model?.projectVersionId
    )
    sessionStorage.setItem('mutiReview', idList)

    setRequestBody()
    setReviewSummary('')
    scrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    handleReload(5, 1)
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        groupId: projectId,
        id: idList,
      }
    }

    setRequestBody(request)
    return request
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {schema?.forms?.reviewerApproveList && (
        <div>
          <ApprovedExpert schema={schema.forms.reviewerApproveList} />
          <br />
        </div>
      )}
      {schema?.forms?.reviewSummary?.forms && (
        <div>
          <ReviewSummaryResultMuti
            isAll={true}
            schema={schema.forms.reviewSummary.forms}
            onComplete={() => {
              handleGetSchema()
            }}
          />
        </div>
      )}

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            // single={{
            //   enable: true,
            //   buttonText: projectList.buttonText || 'บันทึกสรุปผลการพิจารณา',
            //   iconByStatus: true,
            //   hideText: false,
            //   width: 230,
            // }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {reviewSummary && (
        <div>
          <ReviewSummaryResultMuti schema={reviewSummary} onComplete={onComplete} />
        </div>
      )}
    </SidebarProposal>
  )
}
